import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77137176&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=77137176&prod&lang=stylus&"
import style1 from "./index.vue?vue&type=style&index=1&id=77137176&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77137176",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTitle: require('/opt/build/repo/components/PageTitle.vue').default,HeaderMedia: require('/opt/build/repo/components/HeaderMedia.vue').default,RichTitle: require('/opt/build/repo/components/RichComponents/RichTitle.vue').default,RichText: require('/opt/build/repo/components/RichComponents/RichText.vue').default,FoodNav: require('/opt/build/repo/components/Food/FoodNav.vue').default,FoodCategory: require('/opt/build/repo/components/Food/FoodCategory.vue').default,ButtonArrow: require('/opt/build/repo/components/ButtonComponents/ButtonArrow.vue').default,GalleryStandard: require('/opt/build/repo/components/GalleryComponents/GalleryStandard.vue').default,StoreFinder: require('/opt/build/repo/components/StoreFinder/StoreFinder.vue').default})
